import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import ProgressBar from 'react-bootstrap/ProgressBar'
import { ICONS } from '../../img/icons'
import Icon from '../../img/Icon'
import { FaMapMarkerAlt } from "react-icons/fa";

const AlertTemplate = ({ style, options, message, close }) => {
    const [progress, setProgress] = useState(0);
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
            setSeconds(seconds => seconds + 12);
        }, 100);
        return () => clearInterval(interval);
    }, [seconds]);

    useEffect(() => {
        let calculateProgress = (seconds / (options.timeout / 10)) * 100;
        setProgress(calculateProgress);
    }, [seconds]);

    const renderIcon = (type, size) => {
        switch (type) {
            case 'info':
                return <span className="alert-icon"><Icon icon={ICONS.INFO} color='blue' size={size} /></span>;
            case 'success':
                return <span className="alert-icon"><Icon icon={ICONS.SUCCESS} color='green' size={size} /> </span>;
            case 'error':
                return <span className="alert-icon"><Icon icon={ICONS.WARNING} color='yellow' size={size} /></span>;
            case 'location':
                return <span className="alert-icon"><FaMapMarkerAlt fontSize={Number(size) + 2} /> </span>;
            default:
                return null;
        }
    };

    const templates = {
        alternative: () => (
            <div className="custom-alert-alternative">
                <div style={style} className="alert-box">
                    <span className={options.type === 'info' ? "alert-message-info" : "alert-message"}>
                        {renderIcon(options.type, '28')}
                        {message}
                    </span>
                    <button style={style} className={"alert-close alert-close-pesticideoperation-btn btn-close"} onClick={close}></button>
                </div>
            </div>
        ),
        location: () => (
            <div className="custom-alert-alternative">
                <div style={style} className="alert-box">
                    <span className="alert-message">
                        {renderIcon('location', '28')}
                        {message}
                    </span>
                    <button style={style} className={"alert-close alert-close-pesticideoperation-btn btn-close"} onClick={close}></button>
                </div>
            </div>
        ),
        default: () => (
            <div className={options.type === "error" ? "custom-alert alert-error" : "custom-alert container"}>
                <ProgressBar variant={options.type === "error" ? "warning" : "success"} className="alert-timer" now={progress} />
                <div style={style} className="alert-box">
                    <span className={options.type === 'info' ? "alert-message-info" : "alert-message"}>
                        {renderIcon(options.type, '26')}
                        {message}
                    </span>
                    <button style={style} className={options.type === "error" ? "alert-close btn-close alert-close-btn btn-close-white" : "alert-close alert-close-btn btn-close"} onClick={close}></button>
                </div>
            </div>
        ),
    };

    const renderTemplate = templates[options.style] || templates.default;

    return (
        <>
            {renderTemplate()}
        </>
    )
}

export default AlertTemplate;